// extracted by mini-css-extract-plugin
export var divider = "_1g-0";
export var dividerText = "_1g-1";